import { useQuery } from "@tanstack/react-query";
import { type PropsWithChildren } from "react";
import { useClientConfig } from "@/context/clientConfig";
import { EventEditionConfigurationProvider } from "@/exhibitors/context/eventEditionConfiguration";
import { eventEditionConfigurationOptions } from "@/lib/client/exhibitor-listing";

export interface EventEditionProps {
  eventEditionCode: string;
}

export default function EventEdition(
  props: PropsWithChildren<EventEditionProps>,
) {
  const { eventEditionCode, children } = props;
  const {
    siteConfig: { locale },
  } = useClientConfig();

  const { data: configuration } = useQuery(
    eventEditionConfigurationOptions(eventEditionCode, locale),
  );

  if (!configuration) return null;

  return (
    <EventEditionConfigurationProvider value={configuration}>
      {children}
    </EventEditionConfigurationProvider>
  );
}
